import { Reveal, MaskIn, MaskLine } from "@/components/motion";

const DETAILS = [
    {
        label: "Telephone",
        value: "+44 796 138 7639",
        href: "tel:+447961387639",
        id: "contact-phone-link",
    },
    {
        label: "Email",
        value: "info@elcayilconsulting.co.uk",
        href: "mailto:info@elcayilconsulting.co.uk",
        id: "contact-email-link",
    },
    {
        label: "Website",
        value: "elcayilconsulting.co.uk",
        href: "https://elcayilconsulting.co.uk",
        id: "contact-website-link",
    },
    {
        label: "LinkedIn",
        value: "linkedin.com/in/shanualabi",
        href: "https://www.linkedin.com/in/shanualabi/",
        id: "contact-linkedin-link",
    },
];

export default function Contact() {
    return (
        <div>
            <section
                className="mx-auto max-w-7xl px-6 pt-32 md:px-12 md:pt-44"
                data-testid="contact-hero"
            >
                <Reveal y={16}>
                    <p className="eyebrow text-ink/50">Contact</p>
                </Reveal>
                <h1 className="mt-8 max-w-5xl font-serif-d text-4xl leading-[1.1] sm:text-5xl md:text-7xl">
                    <MaskLine delay={0.2}>
                        Start a{" "}
                        <em className="italic text-brand">conversation</em>.
                    </MaskLine>
                </h1>
                <Reveal delay={0.2} className="mt-10 max-w-2xl">
                    <p className="text-[15px] leading-relaxed text-ink/60">
                        Whether you are addressing a specific organisational
                        challenge, developing a sustainability strategy,
                        reviewing governance arrangements or planning your
                        organisation's next stage of growth, we would be
                        pleased to discuss how ELCAYIL can support you.
                    </p>
                </Reveal>
            </section>

            <section
                className="mt-20 border-t border-black/10 md:mt-28"
                data-testid="contact-details"
            >
                <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
                    <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
                        <div className="lg:col-span-7">
                            {DETAILS.map((d, i) => (
                                <Reveal key={d.label} delay={i * 0.06} y={20}>
                                    <div
                                        className="group border-t border-black/10 py-7 md:py-9"
                                        data-testid={`contact-detail-${d.label.toLowerCase()}`}
                                    >
                                        <p className="eyebrow text-ink/40">
                                            {d.label}
                                        </p>
                                        <a
                                            href={d.href}
                                            data-testid={d.id}
                                            target={
                                                d.href.startsWith("http")
                                                    ? "_blank"
                                                    : undefined
                                            }
                                            rel={
                                                d.href.startsWith("http")
                                                    ? "noreferrer"
                                                    : undefined
                                            }
                                            className="row-bg mt-3 inline-block font-serif-d text-2xl transition-colors duration-300 group-hover:text-brand md:text-4xl"
                                        >
                                            {d.value}
                                        </a>
                                    </div>
                                </Reveal>
                            ))}
                            <div className="border-t border-black/10" />
                        </div>

                        <div className="lg:col-span-4 lg:col-start-9">
                            <Reveal delay={0.15}>
                                <p className="eyebrow text-ink/40">
                                    Registered office
                                </p>
                                <address
                                    className="mt-6 font-serif-d text-2xl not-italic leading-snug md:text-3xl"
                                    data-testid="contact-address"
                                >
                                    ELCAYIL CONSULTING LTD.
                                    <br />
                                    26 Northumberland Road
                                    <br />
                                    London, E6 5RN
                                    <br />
                                    United Kingdom
                                </address>
                                <p className="eyebrow mt-10 text-ink/40">
                                    Company number
                                </p>
                                <p
                                    className="mt-3 font-mono2 text-sm"
                                    data-testid="contact-company-number"
                                >
                                    03615690
                                </p>
                                <div className="mt-12 border-l-2 border-brand pl-6">
                                    <p
                                        className="text-sm leading-relaxed text-ink/60"
                                        data-testid="contact-note"
                                    >
                                        Every successful engagement begins with
                                        understanding the challenge. Speak with
                                        ELCAYIL CONSULTING LTD. about your
                                        organisation, objectives or advisory
                                        requirements.
                                    </p>
                                </div>
                            </Reveal>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
